import { ref } from 'vue';

export const showing_smoothen_options_modal = ref(false);

export function show_smoothen_options_modal() {
    showing_smoothen_options_modal.value = true;
}

export function hide_smoothen_options_modal() {
    showing_smoothen_options_modal.value = false;
}
